import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JobAlertsRoutingModule } from './job-alerts-routing.module';
import { JobAlertsComponent } from './job-alerts/job-alerts.component';
import { AddUpdateJobAlertComponent } from './add-update-job-alert/add-update-job-alert.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [JobAlertsComponent, AddUpdateJobAlertComponent],
  imports: [CommonModule, JobAlertsRoutingModule, SharedModule],
})
export class JobAlertsModule {}
